import { IDeferred, IQService } from 'angular';
import { DeferredGoRecorder } from './go-recorder-deferred';
import { VideoSceneController } from 'go-modules/video-scene/video-scene.controller';
import { upgradeNg1Dependency } from '@go-modules/common/ng1-upgrade-factory';

interface GoRecorderStore {
	[id: string]: DeferredGoRecorder;
}

interface GoRecorderDeferredStore {
	[id: string]: IDeferred<VideoSceneController>;
}

const recorderStore: GoRecorderStore = {};
const deferredStore: GoRecorderDeferredStore = {};

export class GoRecorderManagerService {
	public static readonly NG1_INJECTION_NAME = 'goRecorderManagerService' as const;

	/* @ngInject */
	constructor (private $q: IQService) {}

	public get (id: string): DeferredGoRecorder {
		if (!recorderStore[id]) {
			deferredStore[id] = this.$q.defer();
			recorderStore[id] = new DeferredGoRecorder(deferredStore[id].promise);
		}

		return recorderStore[id];
	}

	public register (id: string, recorder: VideoSceneController): DeferredGoRecorder {
		const deferredGoRecorder: DeferredGoRecorder = this.get(id);
		deferredStore[id].resolve(recorder);
		return deferredGoRecorder;
	}

	public unregister (id: string): void {
		delete recorderStore[id];
		delete deferredStore[id];
	}
}
export interface GoRecorderManagerServiceInterface {
	get(id: string): DeferredGoRecorder;
	register(id: string, recorder: VideoSceneController): DeferredGoRecorder;
	unregister(id: string): void;
}

export const goRecorderManagerServiceToken = upgradeNg1Dependency(GoRecorderManagerService);
